module.exports = __webpack_public_path__ + "12a6533f1895ae7a9ef61fd0dea3edcc.png";